import React from 'react'
import { services } from '../constants'
import Icon, { IconName } from '@/components/ui/icon'

const Services: React.FC = () => {
  return (
    <section id="services" className="py-20 bg-gray-900 text-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl font-bold sm:text-4xl">Our Services</h2>
          <p className="mt-4 text-xl text-gray-300 max-w-3xl mx-auto">
            Comprehensive tax and business solutions tailored to your specific needs
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map(service => {
            return (
              <div
                key={service.id}
                className="bg-gray-800 rounded-lg p-6 border border-gray-700 hover:border-blue-500 transition-all duration-300 group"
              >
                <div className="bg-blue-600/10 p-3 rounded-lg inline-block mb-4 group-hover:bg-blue-600/20 transition-all duration-300">
                  <Icon name={service.icon as IconName} className="h-8 w-8 text-blue-400" />
                </div>
                <h3 className="text-xl font-semibold mb-2 group-hover:text-blue-400 transition-colors duration-300">
                  {service.title}
                </h3>
                <p className="text-gray-400">{service.description}</p>
              </div>
            )
          })}
        </div>

        <div className="mt-16 bg-gradient-to-r from-blue-600 to-blue-800 rounded-lg shadow-xl p-8 md:p-10">
          <div className="md:flex items-center justify-between">
            <div className="md:w-2/3 mb-6 md:mb-0">
              <h3 className="text-2xl font-bold mb-2">Ready to optimize your tax situation?</h3>
              <p className="text-blue-100">
                Our team of experts is ready to analyze your unique situation and provide tailored solutions.
              </p>
            </div>
            <div>
              <a
                href="#contact"
                className="inline-block bg-white text-blue-700 px-6 py-3 rounded-lg font-medium hover:bg-gray-100 transition-colors"
              >
                Schedule a Consultation
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Services

